import styled from 'styled-components';

export const TitlePage = styled.h1`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 32px;
	font-weight: 400;
	line-height: 1.1;
	margin-bottom: 32px;
`;
